module.exports = __webpack_public_path__ + "img/12-1_06.302ae590.jpg";